export default {
  features: [],
  mode: 'search',
  keyword: '',
  number: '',
  isSearching: false,
  searchResults: [],
  hasSearched: false
}



// WEBPACK FOOTER //
// ./src/store/modules/dialer/state.js